import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-cc676ed4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "animate" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Acceder", -1))
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label-space" }, "Email", -1))
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label-space" }, "Contraseña", -1))
const _hoisted_7 = { class: "feedback" }
const _hoisted_8 = {
  key: 0,
  class: "spacer"
}

import { ref } from 'vue'
import { useAuth } from '@/store/useAuth'
import router from '@/router'


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginForm',
  setup(__props) {

const store = useAuth()
const email = ref('')
const password = ref('')
const feedback = ref('')

const handleLogin = async () => {
    feedback.value = "Validando credenciales..."
    const success = await store.login(email.value, password.value)
    if(success) {
        feedback.value = "Cargando tu panel de estudios..."
        router.push({name: 'home'})
        return
    }

    feedback.value = store.message
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("form", null, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          placeholder: "ejemplo@ademass.com",
          required: "",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event))
        }, null, 512), [
          [_vModelText, email.value]
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _withDirectives(_createElementVNode("input", {
          type: "password",
          required: "",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event))
        }, null, 512), [
          [_vModelText, password.value]
        ])
      ]),
      _createElementVNode("input", {
        type: "submit",
        value: "Entrar",
        class: "go-btn",
        onClick: _withModifiers(handleLogin, ["prevent"])
      }),
      _createElementVNode("p", _hoisted_7, _toDisplayString(feedback.value), 1),
      (feedback.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})